import mitt from "mitt";
import { onBeforeUnmount } from "vue";
export default function() {
  const senderId = Math.round(Math.random() * 1e10).toString();
  const broadcastEventBus = mitt();
  const channel = new BroadcastChannel("blokkli");
  channel.addEventListener("message", (e) => {
    if (e.data.senderId === senderId) {
      return;
    }
    broadcastEventBus.emit(e.data.name, e.data.data);
  });
  onBeforeUnmount(() => channel.close());
  return {
    ...broadcastEventBus,
    emit(name, data) {
      const event = {
        name,
        data,
        senderId
      };
      channel.postMessage(event);
      broadcastEventBus.emit(name, data);
    }
  };
}
